import { DropdownMenu as KobalteDropdownMenu } from "@kobalte/core/dropdown-menu"
import type { ParentProps } from "solid-js"
import {
  dropdownContentClass,
  dropdownItemLabelClass,
  dropdownItemRecipe,
} from "@/designSystem/components/dropdown-menu.css"
import { Icon } from "@/designSystem/components/icon"
import { useI18nContext } from "@/i18n/i18n-solid"

export type ImageNodeMenuAttributes = {
  title: string
  size: string
}

type ImageMenuProps = ParentProps<{
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
  triggerClass: string
  triggerLabel: string
  onTriggerPointerDown: () => void
  onTriggerClick: (event: MouseEvent) => void
  onTriggerKeyDown: (event: KeyboardEvent) => void
  onTriggerDragStart: (event: DragEvent) => void
  onTriggerDragEnd: () => void
  attributes: ImageNodeMenuAttributes
  onUpdateImageAttributes: (attrs: Partial<ImageNodeMenuAttributes>) => void
  onDelete: () => void
}>

export function ImageMenu(props: ImageMenuProps) {
  const { LL } = useI18nContext()

  return (
    <KobalteDropdownMenu open={props.isOpen} onOpenChange={props.onOpenChange}>
      <KobalteDropdownMenu.Trigger
        class={props.triggerClass}
        aria-label={props.triggerLabel}
        data-block-node-menu-trigger="true"
        draggable="true"
        onPointerDown={props.onTriggerPointerDown}
        onClick={props.onTriggerClick}
        onKeyDown={props.onTriggerKeyDown}
        onDragStart={props.onTriggerDragStart}
        onDragEnd={props.onTriggerDragEnd}
      >
        {props.children}
      </KobalteDropdownMenu.Trigger>
      <KobalteDropdownMenu.Portal>
        <KobalteDropdownMenu.Content class={dropdownContentClass}>
          <KobalteDropdownMenu.Item
            class={dropdownItemRecipe({ hue: "rose" })}
            onSelect={props.onDelete}
          >
            <Icon name="trash-2" size="18" />
            <span class={dropdownItemLabelClass}>{LL().common.delete()}</span>
          </KobalteDropdownMenu.Item>
        </KobalteDropdownMenu.Content>
      </KobalteDropdownMenu.Portal>
    </KobalteDropdownMenu>
  )
}
